module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-wasou-costume-ef98f81f2f19a78929dd4b4acbb21b60.png";